import { scroller } from "react-scroll";
import React, { useEffect, useState } from 'react'
import Logo from '../Images/koyark-logo.png'
import background from '../Images/backg1.jpg';
import Business from "./Business";
import About from "./About";
import Footer from "./Footer";
import '../Css/Home.css';
import Contact from "./Contact";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import LazyShow, {SlideRight} from "./LazyShow";

require('typeface-quicksand');
// const boxVariant = {
//     visible: { opacity: 1, scale:1,transform :{translateY:"-50%"}, transition: { duration: 0.5 } },
//     hidden: { opacity: 0, scale: 0 }
// };
const Home = () => {
    const [show, setShow] = useState(false);
    const [activeLink, setActiveLink] = useState('Home');
    const whiteHeader = () => {
        if (window.scrollY > 100) {
            setShow(true);
        } else {
            setShow(false);
        }
    }
    const scrollToServices = () => {
        scroller.scrollTo("services", {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
        setActiveLink('Our Services');

    };
    const scrollToAbout = () => {
        scroller.scrollTo("about", {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
        setActiveLink('About Us');
    };
    const scrollToContact = () => {
        scroller.scrollTo("contact", {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
        setActiveLink('Contact Us');
    };
    const scrollToHome = () => {
        scroller.scrollTo("home", {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
        setActiveLink('Home');
    };

    const setActive = () => {
        window.addEventListener('scroll', () => {
            if (window.scrollY >= 700) {
                setActiveLink('Our Services');
            }
            if (window.scrollY >= 1500) {
                setActiveLink('About Us');
            }
            if (window.scrollY >= 2000) {
                setActiveLink('Contact Us');
            }
            if (window.scrollY <= 600) {
                setActiveLink('Home');
            }
        })
    }
    
    // const control = useAnimation();
    // const [ref, inView] = useInView();
    // useEffect(() => {
    //     if (inView) {
    //       control.start("visible");
    //     } else {
    //       control.start("hidden");
    //     }
    //   }, [control, inView]);
    useEffect(() => {
        setActive();
        window.addEventListener('scroll', whiteHeader);
        window.addEventListener('scroll', setActive);
        return () => window.removeEventListener('scroll', whiteHeader);
    }, []);
    return (
        <div>
            <div className='home_wrapper' id="home">
                <div className={`header ${show && "header_white"}`}>
                    <img src={Logo} alt="Logo" className='logo' />
                    <ul className='menu'>
                        <li className='menu_item'>
                            <a className={`menu_link ${activeLink == "Home" ? 'activeLink' : ""}`} role={'button'} onClick={scrollToHome} >Home</a>
                        </li>
                        <li className='menu_item'>
                            <a className={`menu_link ${activeLink == "Our Services" ? 'activeLink' : ""}`} role={'button'} onClick={scrollToServices}>Our Services</a>
                        </li>
                        <li className='menu_item'>
                            <a className={`menu_link ${activeLink == "About Us" ? 'activeLink' : ""}`} role={'button'} onClick={scrollToAbout}>About Us</a>
                        </li>
                        <li className='menu_item'>
                            <a className={`menu_link ${activeLink == "Contact Us" ? 'activeLink' : ""}`} role={'button'} onClick={scrollToContact}>Contact Us</a>
                        </li>
                    </ul>
                    <button className='call_btn'><a href='tel:9716279387'>Call Now</a></button>
                </div>
                <SlideRight>
                    <div className='header_content'>
                        <h1>Lorem ipsum dolor sit amet</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                </SlideRight>
                <div className='background_image'>
                    <img src={background}/>
                </div>
                <div className='overlay'></div>
            </div>
            <Business />
            <About />
            <Contact />
            <Footer />
        </div>
    )
}

export default Home